// src/components/gavion/i18n/modules/privacy.fr.ts
export const privacyFr = {
  title: "Confidentialité",
  officer: {
    title: "Responsable de la protection des renseignements personnels",
    name: "Nom",
    email: "Courriel",
    hint: "Affiché dans le pied des courriels et sur la page de désabonnement (Loi 25).",
    invalid_email: "Courriel invalide.",
  },
  retention: {
    title: "Durées de conservation",
    recording_days: "Enregistrements d'appels (jours)",
    transcript_days: "Transcriptions de réunions (jours)",
    audit_days: "Journal d'audit (jours)",
    range: "Entre %{min} et %{max} jours.",
    fixed:
      "Durées fixes : événements d'automatisation traités 90 jours, extraits de courriels des non-clients 3 ans, archives d'export 24 h, exclusions téléphoniques 3 ans, exclusions courriel et exclusions après effacement : toujours.",
  },
  save: "Enregistrer",
  saved: "Paramètres enregistrés.",
  search: {
    label: "Entreprise ou personne",
    placeholder: "Nom, courriel ou téléphone",
    button: "Rechercher",
    none: "Aucun résultat.",
    select: "Choisir",
    selected: "Sélection : %{name}",
    contacts: "%{smart_count} contact |||| %{smart_count} contacts",
    via_contact: "via le contact %{name}",
    help: "Cherche le nom, le courriel ou le téléphone de l'entreprise et de ses contacts. Un contact sans entreprise n'est pas trouvé : l'export et l'effacement portent sur une entreprise entière.",
  },
  export: {
    title: "Exporter les données d'une personne",
    hint: "Produit une archive ZIP avec toutes les données liées (demande d'accès, Loi 25). L'action est journalisée.",
    button: "Exporter",
    running: "Préparation de l'archive…",
    ready: "Archive prête : %{files} fichiers joints, %{missing} introuvables.",
    download: "Télécharger l'archive",
    expires: "Lien valide jusqu'au %{date}.",
  },
  erase: {
    title: "Effacer une personne",
    hint: "Supprime ou anonymise toutes les données de l'entreprise et de ses contacts. Irréversible.",
    button: "Effacer…",
    dialog_title: "Effacer définitivement « %{name} »",
    warning:
      "Cette action est irréversible. Les numéros et courriels de la personne restent dans la liste d'exclusion pour qu'elle ne soit plus jamais contactée.",
    reason: "Motif",
    reasons: {
      person_request: "Demande de la personne",
      cai_order: "Ordonnance de la Commission d'accès à l'information",
      other: "Autre",
    },
    ack: "Je comprends que cette action est irréversible.",
    confirm_label: "Tapez le nom exact de l'entreprise pour confirmer",
    confirm: "Effacer définitivement",
    cancel: "Annuler",
    done: "Effacement terminé.",
    counts: "Lignes traitées",
    purge:
      "%{smart_count} fichier sera supprimé du stockage cette nuit. |||| %{smart_count} fichiers seront supprimés du stockage cette nuit.",
    residual:
      "Attention : %{smart_count} colonne contient encore une valeur de la personne. Vérifiez avant de clore la demande. |||| Attention : %{smart_count} colonnes contiennent encore une valeur de la personne. Vérifiez avant de clore la demande.",
    residual_unknown:
      "Effacement fait, mais résidus inconnus : la vérification des données restantes a échoué. Ne considérez pas la demande comme close ; contactez le soutien technique.",
  },
  audit: {
    title: "Journal d'audit",
    action: "Action",
    all_actions: "Toutes les actions",
    at: "Date",
    actor: "Auteur",
    entity: "Objet",
    system: "Système",
    empty: "Aucune entrée.",
    previous: "Précédent",
    next: "Suivant",
    page: "Page %{page} sur %{pages}",
    actions: {
      erasure_person: "Effacement d'une personne",
      erasure_residual: "Vérification après effacement",
      export_person: "Export d'une personne",
      settings_update: "Paramètres modifiés",
      recording_play: "Écoute d'un enregistrement",
      user_invite: "Invitation",
      user_role_change: "Changement de rôle",
      user_disable: "Désactivation d'un utilisateur",
      suppression_remove: "Retrait d'une exclusion",
      api_key_create: "Clé API créée",
      api_key_revoke: "Clé API révoquée",
      campaign_schedule: "Campagne planifiée",
      campaign_cancel: "Campagne annulée",
      export_report: "Export de rapport",
    },
  },
  errors: {
    forbidden: "Accès refusé : réservé aux administrateurs.",
    not_found: "Entreprise introuvable.",
    already_erased: "Cette entreprise a déjà été effacée.",
    confirmation_mismatch: "Le nom tapé ne correspond pas.",
    invalid_reason: "Motif invalide.",
    invalid_email: "Courriel invalide.",
    out_of_range: "Valeur hors limites.",
    not_integer: "Entrez un nombre entier.",
    export_too_large:
      "L'archive dépasse 60 Mo. Contactez le soutien technique.",
    query_too_short: "Entrez au moins 2 caractères.",
    export_failed:
      "L'export a échoué. Réessayez ; si l'erreur revient, contactez le soutien technique.",
    unauthorized: "Session expirée. Reconnectez-vous, puis réessayez.",
    invalid_body: "Demande invalide. Rechargez la page, puis réessayez.",
    method_not_allowed:
      "Demande refusée par le serveur. Rechargez la page, puis réessayez.",
    network: "Connexion impossible. Vérifiez votre réseau et réessayez.",
    unknown: "Erreur inattendue (code : %{code}).",
  },
};
